import { createFileRoute } from "@tanstack/react-router";
import { OverlapAnalysis } from "@/components/concepts/OverlapAnalysis";

export const Route = createFileRoute("/concepts/overlap")({
  component: OverlapPage,
});

function OverlapPage() {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold">Compare Concepts</h2>
      <OverlapAnalysis />
    </div>
  );
}
